export class LoadComuniINModel  {
    codiProvincia: string
}